import PropTypes from 'prop-types';
import React, { Component } from 'react';

import Icon from '../Atoms/Icon';

const propTypes = {
  onSearch: PropTypes.func.isRequired,
  searchQueryPrefix: PropTypes.string,
  query: PropTypes.string,
  placeholderText: PropTypes.string,
};

const defaultProps = {
  searchQueryPrefix: 'You searched for',
  query: '',
};

class SearchFilter extends Component {
  constructor(props) {
    super(props);

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmitClick = this.handleSubmitClick.bind(this);

    this.state = { query: this.props.query };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.query === this.state.query) return;
    this.setState({ query: nextProps.query });
  }

  handleInputChange(event) {
    this.setState({ query: event.currentTarget.value });
  }

  handleSubmitClick(event) {
    event.preventDefault();
    this.props.onSearch(this.state.query);
  }

  render() {
    return (
      <div className="SearchFilter">
        <div className="SearchFilter_title">{this.props.searchQueryPrefix}:</div>
        <div className="SearchFilter_field">
          <form onSubmit={this.handleSubmitClick}>
            <input
              type="search"
              className="SearchFilter_input"
              value={this.state.query}
              onChange={this.handleInputChange}
              placeholder={this.props.placeholderText}
            />
            <button type="submit" className="SearchFilter_submitButton">
              <Icon blockName="SearchFilter_submitIcon" id="search" />
            </button>
          </form>
        </div>
      </div>
    );
  }
}

SearchFilter.propTypes = propTypes;
SearchFilter.defaultProps = defaultProps;

export default SearchFilter;
